import { DynamicInput } from '@labrav/react-components'
import React from 'react'
import { Typography } from '@mui/material'
import { useFormikContext } from 'formik'
import {
  MicrosoftCloudSettingsSections,
  FlyoutCloudSettingsSectionsProps,
} from '../../../../../modules/flyOutOnboarding/types'
import { useStyles } from './Prerequisites.styles'
import clsx from 'clsx'
import { prerequisitesConfig } from '../../constants'

export const Prerequisites: React.FC<{ isFormLocked: boolean }> = ({
  isFormLocked,
}) => {
  const { classes } = useStyles()
  const formik = useFormikContext<FlyoutCloudSettingsSectionsProps>()
  return (
    <div className={clsx(classes.prerequisitesContainer)}>
      <div
        className={classes.choiceContainer}
        data-testid="microsoft-prerequisites"
      >
        {prerequisitesConfig.map(config => (
          <DynamicInput
            key={config.id}
            field={{
              title: (
                <div className={classes.inLineInfo}>
                  <Typography className={classes.checkBoxText}>
                    {config.text}
                  </Typography>
                </div>
              ),
              placeHolder: '',
              id: config.id,
              isRequired: true,
              humanReadableKey: config.id,
              isCustom: false,
              defaultValue: undefined,
              dataType: 'bool',
              isReadOnly: isFormLocked as boolean,
            }}
            formik={formik}
            prefix={MicrosoftCloudSettingsSections.PREREQUISITES}
          />
        ))}
      </div>
    </div>
  )
}
